module.exports = __webpack_public_path__ + "static/img/master-1.4ea6316a.png";